import "core-js/modules/es.array.reduce.js";
import { mixin as pluginMinx } from '@/plugin/index.min.js';
import Card from './card';
import EmapPlugin from './plugins';
export default {
  name: 'resListView',
  EmapPlugin,
  components: {
    Card
  },
  mixins: [pluginMinx],
  props: {
    /**
     * 列表数据
     */
    data: {
      type: Array,
      default: () => []
    },

    /**
     * 是否显示多选
     */
    selection: {
      type: Boolean,
      default: false
    },

    /**
     * 分页参数，若提供此属性则显示分页条，具体参数可参考 http://registry.npm.wisedu.com:3000/we-ui#/zh-CN/component/pagination
     */
    pager: {
      type: Object,
      default: () => {}
    },

    /**
     * 卡片宽度，若提供此属性则为多列卡片，使用另一种布局风格
     */
    cardWidth: {
      type: Number,
      default: 0
    },

    /**
     * 辅助卡片对齐参数，如果卡片太小导致换行对齐有问题，可适当调大此参数
     */
    cardOffset: {
      type: Number,
      default: 6
    },

    /**
     * 自定义列表区域的样式，可实现自定义高度，滚动，背景色等等
     */
    listStyle: {
      type: Object
    },

    /**
     * 自定义title样式
     */
    titleStyle: {
      type: Object
    },
    emptyText: {
      type: String,
      default: "暂无数据"
    }
  },
  data: () => ({
    checked: [],
    // 已选中的行索引
    loadedData: [],
    loading: false,
    skeletonLoading: true
  }),
  computed: {
    options() {
      // 允许插件对默认和传入的 props 进行预处理
      const propKeys = this.$options._propKeys;
      const propsData = propKeys.reduce((ret, item) => ({ ...ret,
        [item]: this[item]
      }), {});
      return this.$applyPluginsWaterfall('props', propsData);
    },

    formatedData() {
      const {
        loadedData
      } = this;
      return this.$applyPluginsWaterfall('format-data', loadedData) || [];
    },

    multiCol() {
      return this.cardWidth > 0;
    },

    renderedListStyle() {
      const {
        listStyle = {},
        multiCol
      } = this;
      return multiCol ? {
        'grid-template-columns': `repeat(auto-fit, minmax(${this.cardWidth}px, 1fr))`,
        ...listStyle
      } : listStyle;
    }

  },
  watch: {
    data() {
      this.reload();
    }

  },

  async created() {
    this.$applyPlugins('init');
    this.loading = true;
    await this.$applyPluginsAsyncWaterfall('fetch-meta');
    await this.fetchData();
    this.loading = false;
  },

  methods: {
    /**
     * 重新加载数据
     * @vuese
     * @param {Object} query 查询的附加参数
     */
    reload(query) {
      return this.fetchData(query);
    },

    async fetchData(query = {}) {
      const {
        data = null
      } = this.options;
      this.loading = true;
      const result = await this.$applyPluginsAsyncWaterfall('fetch-data', data, query);
      this.loading = false;
      this.loadedData = result; // 处理分页参数

      const formatedPage = this.$applyPluginsWaterfall('format-page', this.pager, result) || {};
      Object.keys(formatedPage).forEach(key => this.pager[key] = formatedPage[key]);
    },

    /**
      * 行单击事件触发，参数为点击的元素和行索引
    */
    handleClick(item, index, $event) {
      this.$emit('click', item, index, $event);
    },

    /**
     * 多选框点击事件触发，参数为点击的元素、选中状态和行索引
     */
    handleCheck(value, item, index) {
      this.$set(this.checked, index, value);
      this.$emit('change', item, value, index);
    },

    cardStyle() {
      return this.cardWidth ? {
        width: '100%'
      } : null;
    },

    /**
     * 获取选择的列表
     * @vuese
     */
    getSelected() {
      const {
        formatedData,
        checked
      } = this;
      return formatedData.filter((item, index) => checked[index]);
    },

    /**
     * 清空多选
     * @vuese
     */
    clearSelection() {
      this.checked = [];
    },

    /**
     * 选中所有行（多选模式）
     * @vuese
     */
    selectAll() {
      this.checked = new Array(this.data.length).fill(true);
    },

    /**
     * pageSize 改变时会触发，参数为每页条数
     */
    hanlePageSizeChange(...args) {
      this.$emit('size-change', ...args);
      this.fetchData({
        pageNumber: this.pager.currentPage,
        pageSize: args[0]
      });
    },

    hanlePageCurrentChange(...args) {
      this.$emit('current-change', ...args);
      this.fetchData({
        pageNumber: args[0],
        pageSize: this.pager.pageSize
      });
    }

  }
};